var _style, _path, _path2, _polygon, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterPole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309 1124",
    style: {
      enableBackground: "new 0 0 309 1124"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010101;}\n\t.st1{fill:#49A942;}\n\t.st2{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3RC-lightpost") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.8,165.4c-0.2-0.4-2.6-3.9-2.9-4.4c-8.4-70.5-72.3-120.9-142.8-112.6C85.1,55.5,38.6,102,31.6,161 c-0.3,0.4-2.7,4.1-2.9,4.5s-1.5,9.6,0,19.8H31c0.3,4.5,0.9,9.1,1.7,13.5v1.5l0.4,0.7c7.7,38.6,32.5,71.6,67.6,89.6v12.1 c-11.1,5.4-17.8,12.4-17.8,20v32.5h0.1c1.4,12.3,20.2,22.7,46.6,27.2V1124h59.7V382.1c25.3-4.6,43.3-14.8,44.7-26.8h0.1v-1.5l0,0 v-31c0-7.6-6.7-14.6-17.8-20v-11.2c41-20.2,68.2-60.7,71.4-106.2h2.3C291.3,175,290.1,165.9,289.8,165.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.3,110.7c13.5-2.7,27.2-4,40.9-4c50,0,93.9,17.1,118.3,42.6c-14.9-65.1-79.7-105.8-144.7-90.9 c-2.8,0.6-5.6,1.4-8.4,2.2C121.4,77.2,119.4,93.9,118.3,110.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "177.7,1048.7 168.4,1054.5 168.4,343.3 177.7,346.4 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.2,116c-13.9,0-27.8,1.4-41.4,4.2c-2.6,69.1,13.5,118,21.4,137.4c6.3-0.9,12.7-1.3,19.1-1.3 c31.9,0,57.7,10.6,57.7,23.7v3c39.6-20.9,64.5-62,64.4-106.8c0-2.9-0.1-5.8-0.3-8.6C261.7,137.4,214.5,116,159.2,116z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.8,282.9c16.6,0.4,31.1,2.8,43,7v-9.8c-12-3.8-26-6-41.8-6.5L161.8,282.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.2,322.9c-12.4-6.8-32.2-13.1-63-13.5l-1.3,9.2c33.9,0.1,53.4,7.9,64.2,15L221.2,322.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPole);
export default __webpack_public_path__ + "static/media/footer-pole.fbe5ddee90f8223d196d45f25971cce2.svg";
export { ForwardRef as ReactComponent };